import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment.prod';
import { LoginService } from './services/login.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  Currency: string = environment.Currency;  // Default currency
  formattedCurrency: string = '';

  textDir; 
  title = 'Karage POS | Admin';
  lang = "en";
  constructor(private translateService: TranslateService,private api:LoginService) {
    translateService.addLangs(['en', 'ar']);
    translateService.setDefaultLang('en');
   
    
  }
 
  ngOnInit() {
    
  }
  changeCurrency(newCurrency: string) {
    this.Currency = newCurrency;
    this.formattedCurrency = this.api.formatCurrency(newCurrency);
  }
}
